import type { ReactNode } from 'react';
import { haptic } from '../../lib/native.js';

export function Segmented<T extends string>({
  value,
  options,
  onChange,
  label,
  disabled,
  size = 'md',
  reselect = false,
}: {
  value: T | null | undefined;
  options: readonly { value: T; label: ReactNode; title?: string }[];
  onChange: (value: T) => void;
  label: string;
  disabled?: boolean;
  size?: 'sm' | 'md';
  /** Tapping the selected option fires onChange again (the value is an estimate, e.g. last button pressed). */
  reselect?: boolean;
}): ReactNode {
  const idx = options.findIndex((o) => o.value === value);
  return (
    <div
      className="segmented"
      role="radiogroup"
      aria-label={label}
      data-size={size}
      aria-disabled={disabled}
      style={{ ['--n' as string]: options.length, ['--i' as string]: Math.max(0, idx) }}
    >
      {idx >= 0 && <span className="segmented-thumb" aria-hidden="true" />}
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="radio"
          aria-checked={value === o.value}
          disabled={disabled}
          title={o.title}
          onClick={() => {
            if (o.value === value && !reselect) return;
            haptic('selection');
            onChange(o.value);
          }}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
